import React, { useState, useEffect } from 'react';
import './PublicEdges.css';

// Fixed: Use real picks API with Aurora database
const EDGES_API = 'https://sqhpzxuimundhzstmjqsr6w4dq0jyyia.lambda-url.us-east-1.on.aws/api/picks';

const PublicEdges = () => {
  const [picks, setPicks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({ wins: 0, losses: 0, pushes: 0, pending: 0, win_rate: 0 });

  useEffect(() => {
    fetchPicks();
  }, []);

  const fetchPicks = async () => {
    try {
      const response = await fetch(`${EDGES_API}?days=7`);
      const data = await response.json();
      setPicks(data.picks || []);
      setStats(data.stats || { wins: 0, losses: 0, pushes: 0, pending: 0, win_rate: 0 });
    } catch (error) {
      console.error('Failed to fetch picks:', error);
    } finally {
      setLoading(false);
    }
  };

  const getConfidenceColor = (confidence) => {
    if (confidence === 'HIGH') return '#22C55E';
    if (confidence === 'MEDIUM') return '#F59E0B';
    return '#94A3B8';
  };

  const formatDate = (dateStr) => {
    const d = new Date(dateStr + 'T12:00:00');
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  };

  const getResultBadge = (result) => {
    if (result === 'won') return <span className="result-badge won">✓ Won</span>;
    if (result === 'lost') return <span className="result-badge lost">✗ Lost</span>;
    if (result === 'push') return <span className="result-badge push">— Push</span>;
    return <span className="result-badge pending">⏳ Pending</span>;
  };

  if (loading) {
    return (
      <div className="public-edges">
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading AI edges...</p>
        </div>
      </div>
    );
  }

  // Group picks by date
  const picksByDate = picks.reduce((acc, pick) => {
    const date = pick.date;
    if (!acc[date]) acc[date] = [];
    acc[date].push(pick);
    return acc;
  }, {});

  return (
    <div className="public-edges">
      <header className="public-header">
        <div className="brand-header">
          <span className="brand-name">BetPilot</span>
          <span className="tagline">Your AI Betting Co-Pilot</span>
        </div>
        
        <h1>AI Edges</h1>
        <p>Transparent picks with AI reasoning • Updated when edges are found</p>
        
        <div className="stats-bar">
          <div className="stat">
            <span className="stat-label">Record (7d)</span>
            <span className="stat-value">{stats.wins}-{stats.losses}-{stats.pushes}</span>
          </div>
          <div className="stat">
            <span className="stat-label">Win Rate</span>
            <span className="stat-value">{stats.win_rate}%</span>
          </div>
          <div className="stat">
            <span className="stat-label">Pending</span>
            <span className="stat-value">{stats.pending}</span>
          </div>
        </div>
      </header>

      <div className="picks-container">
        {picks.length === 0 ? (
          <div className="empty-state">
            <h3>No picks in the last 7 days</h3>
            <p>Sometimes the best bet is no bet. We only post when we find real edges.</p>
          </div>
        ) : (
          Object.entries(picksByDate)
            .sort(([a], [b]) => b.localeCompare(a))
            .map(([date, datePicks]) => (
              <div key={date} className="date-group">
                <h3 className="date-header">{formatDate(date)}</h3>
                {datePicks.map((pick) => (
                  <div key={pick.pick_id} className="pick-card">
                    <div className="pick-header">
                      <span className="league-badge">{pick.league}</span>
                      <span 
                        className="confidence-badge"
                        style={{ backgroundColor: getConfidenceColor(pick.confidence) }}
                      >
                        {pick.confidence}
                      </span>
                      {getResultBadge(pick.result)}
                    </div>
                    
                    <div className="pick-main">
                      <div className="matchup">{pick.matchup}</div>
                      <div className="selection">{pick.selection}</div>
                      <div className="odds">{pick.odds > 0 ? '+' : ''}{pick.odds} ({pick.book})</div>
                    </div>
                    
                    <div className="pick-metrics">
                      <div className="metric">
                        <span className="metric-label">Fair Prob</span>
                        <span className="metric-value">{(pick.fair_prob * 100).toFixed(1)}%</span>
                      </div>
                      <div className="metric">
                        <span className="metric-label">Edge</span>
                        <span className="metric-value" style={{ color: pick.ev_pct > 0 ? '#22C55E' : '#EF4444' }}>
                          {pick.ev_pct > 0 ? '+' : ''}{pick.ev_pct.toFixed(2)}%
                        </span>
                      </div>
                    </div>
                    
                    {pick.rationale && pick.rationale.length > 0 && (
                      <div className="pick-rationale">
                        <div className="rationale-label">Why this pick:</div>
                        <ul>
                          {pick.rationale.map((r, i) => <li key={i}>{r}</li>)}
                        </ul>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ))
        )}
      </div>

      <footer className="public-footer">
        <p>For entertainment only. 21+ | Gamble responsibly.</p>
        <a href="/" className="cta-button">Try BetPilot AI Free →</a>
      </footer>
    </div>
  );
};

export default PublicEdges;
